export enum VirtualGridRowHeight {
  small = 'small',
  medium = 'medium',
  large = 'large'
}
